import React from 'react';
import { Link } from '@reach/router';
import { Box, Text, ResponsiveContext } from 'grommet';
import { GET_BILLING_PAY_PLAN_account_items_payplans_items } from './graphql/__generated__/GET_BILLING_PAY_PLAN';
import { StyledDataTable } from '..';
import { PolicyPayPlans } from '.';
import ResponsiveGrid from '../responsiveGrid';

export interface PayPlansCollection {
  billing_method: string;
  default_payment_method: string;
  pay_plan: string;
  payment_method_type: string;
  payplan_key: string;
  policy: string[];
  policy_number: string;
  policy_period_id: string;
  response_bill_indicator: string;
}

export interface paymentPlanData {
  payPlans:
    | GET_BILLING_PAY_PLAN_account_items_payplans_items[]
    | null
    | undefined;
}

interface billingpayPlansProps {
  loading?: boolean;
  error?: Error;
  plansData?: paymentPlanData;
  onClick: Function;
  method?: String;
  title?: String;
  automaticPaymentStatus?: string | null;
  policyPresent?: boolean;
}

export default ({
  loading,
  error,
  plansData,
  onClick,
  method,
  title,
  automaticPaymentStatus,
  policyPresent
}: billingpayPlansProps) => {
  if (loading) {
    return <Text>Loading...</Text>;
  }

  if (error) {
    return <Text>Error</Text>;
  }

  return (
    <ResponsiveContext.Consumer>
      {responsive => (
        <Box align="start" flex overflow="hidden">
          {plansData?.payPlans?.length && policyPresent ? (
            <Box fill>
              <ResponsiveGrid
                rows={['auto']}
                alignContent="start"
                columns={['1/2', '1/2']}
                areas={{
                  xsmall: [
                    { name: 'policies', start: [0, 0], end: [0, 0] },
                    { name: 'method', start: [1, 0], end: [1, 0] }
                  ],
                  small: [
                    { name: 'policies', start: [0, 0], end: [0, 0] },
                    { name: 'method', start: [1, 0], end: [1, 0] }
                  ],
                  medium: [
                    { name: 'policies', start: [0, 0], end: [0, 0] },
                    { name: 'method', start: [1, 0], end: [1, 0] }
                  ],
                  large: [
                    { name: 'policies', start: [0, 0], end: [0, 0] },
                    { name: 'method', start: [1, 0], end: [1, 0] }
                  ],
                  xlarge: [
                    { name: 'policies', start: [0, 0], end: [0, 0] },
                    { name: 'method', start: [1, 0], end: [1, 0] }
                  ]
                }}
                gap="24px"
              >
                <Box gridArea="policies" flex>
                  <Text>Current Policies</Text>
                  {plansData.payPlans.map(
                    (
                      payPlan: GET_BILLING_PAY_PLAN_account_items_payplans_items
                    ) => {
                      if (
                        payPlan?.policy &&
                        payPlan.policy.policy_number !== null
                      ) {
                        return (
                          <PolicyPayPlans
                            planData={payPlan}
                            onClick={onClick}
                          />
                        );
                      }
                      return <></>;
                    }
                  )}
                </Box>
                <Box gridArea="method">
                  <Text margin={{ bottom: '15px' }}>Payment Method</Text>
                  <Box
                    background="#F5F7FA"
                    pad={{ top: '13px', left: '10px', bottom: '17px' }}
                  >
                    <Text color="#041E41" size="12px">
                      {title}
                    </Text>
                    <Text color="#041E41" size="14px" weight="bold">
                      {method}
                    </Text>
                    {automaticPaymentStatus && (
                      <Box>
                        <Text size="12px">Automatic Payments</Text>
                        <Text size="14px" weight="bold">
                          {automaticPaymentStatus}
                        </Text>
                      </Box>
                    )}
                  </Box>
                </Box>
              </ResponsiveGrid>
            </Box>
          ) : (
            <Text size="medium">
              No payment plans found for this account...
            </Text>
          )}
        </Box>
      )}
    </ResponsiveContext.Consumer>
  );
};
